import store from '../index';
import types from '../types/slot';
import actions from '../actions/slot';

export const setSlotDays = (data) => {
  return store().dispatch({
    type: types.SLOT_SET,
    key: 'days',
    data,
  });
};

export const resetSlotDays = () => {
  return store().dispatch({
    type: types.SLOT_SET,
    key: 'days',
    data: [],
  });
};

export const addSlotTemplate = async (data) => {
  return actions.addSlotTemplate(data);
};

export const getSlotTemplatesById = async (queryString) => {
  return actions.getSlotTemplatesById(queryString);
};

export const getSlotTemplates = async (queryString) => {
  return actions.getSlotTemplates(queryString);
};

export const getZonesByStoreIdForSlots = async (queryString) => {
  return actions.getZonesByStoreIdForSlots(queryString);
};

export const getSlotsByZoneIdForTwoDays = async (zoneId, date) => {
  return actions.getSlotsByZoneIdForTwoDays(zoneId, date);
};

export const deleteSlotTemplates = async (data) => {
  return actions.deleteSlotTemplates(data);
};
export const changeStatusSlotTemplates = async (data) => {
  return actions.changeStatusSlotTemplates(data);
};
export const editSlotTemplate = async (data, id) => {
  return actions.editSlotTemplate(data, id);
};
export const getSlotZone = async (queryString) => {
  return actions.getSlotZone(queryString);
};

export const getSlots = async (queryString) => {
  return actions.getSlots(queryString);
};

export const getZoneSlotTemplates = async (data) => {
  return actions.getZoneSlotTemplates(data);
};

export const editSlot = async (data, id) => {
  return actions.editSlot(data, id);
};

export const addSlot = async (data) => {
  return actions.addSlot(data);
};

export const deleteSlot = async (id) => {
  return actions.deleteSlot(id);
};

export const createZoneSlotTemplates = async (data) => {
  return actions.createZoneSlotTemplates(data);
};

export const getDownloadLinkSlotCapacity = async () => {
  return actions.getDownloadLinkSlotCapacity();
};

export const importFileZoneSlotTemplate = async (data) => {
  return actions.importFileZoneSlotTemplate(data);
};

export const changeStatusZoneSlotTemplates = async (payload) => {
  return actions.changeStatusZoneSlotTemplates(payload);
};

export const deleteZoneSlotTemplates = async (payload) => {
  return actions.deleteZoneSlotTemplates(payload);
};

export const generateSlotForZone = async (zoneId, slotId) => {
  return actions.generateSlotForZone(zoneId, slotId);
};
